/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsServerNetworkClose: {
  name: 'server-network-close';
  data: string;
} = {
  name: 'server-network-close',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 0H7v10h10V4ZM2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm10-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2.707-12.707a1 1 0 0 1 0 1.414L13.414 9l1.293 1.293a1 1 0 0 1-1.414 1.414L12 10.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 9 9.293 7.707a1 1 0 0 1 1.414-1.414L12 7.586l1.293-1.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
